var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManuicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 25,
    viewBox: "0 0 34 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0691 14.2857L2.07373 14.2857C0.928442 14.2857 -1.5422e-07 13.4862 -9.93504e-08 12.5C-4.44807e-08 11.5138 0.928442 10.7143 2.07373 10.7143L30.0691 10.7143C31.2144 10.7143 32.1429 11.5138 32.1429 12.5C32.1429 13.4862 31.2144 14.2857 30.0691 14.2857Z",
    fill: "#3E4958"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-9.93505e-08 1.78571C-4.44807e-08 0.799492 0.799491 4.44808e-08 1.78571 9.93505e-08L31.25 1.73863e-06C32.2362 1.7935e-06 33.0357 0.799493 33.0357 1.78572C33.0357 2.77194 32.2362 3.57143 31.25 3.57143L1.78571 3.57143C0.799491 3.57143 -1.5422e-07 2.77194 -9.93505e-08 1.78571Z",
    fill: "#3E4958"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5714 25L2.57143 25C1.15127 25 6.12126e-07 24.2005 -9.93505e-08 23.2143C-9.64096e-07 22.2281 1.15127 21.4286 2.57143 21.4286L29.5714 21.4286C30.9916 21.4286 32.1429 22.228 32.1429 23.2143C32.1429 24.2005 30.9916 25 29.5714 25Z",
    fill: "#3E4958"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManuicon);
export default __webpack_public_path__ + "static/media/manu icon.20d65301cb4733a7519be9e7ae375c37.svg";
export { ForwardRef as ReactComponent };